var _defs, _polygon, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #1c274c;\n      }\n\n      .st2 {\n        fill: #d47500;\n      }\n\n      .st1 {\n        fill-rule: evenodd;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.7 125 541.7 181.3 608.3 234.7 608.3 125 541.7 125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.3,274.7V116.7c0-23-18.7-41.7-41.7-41.7h-83.3c-23,0-41.7,18.7-41.7,41.7v24.7l-13.6-10.9c-45.7-36.5-110.5-36.5-156.2,0L51.1,347.1c-10.8,8.6-12.5,24.4-3.9,35.1,8.6,10.8,24.4,12.5,35.1,3.9l26-20.8v343h-41.7c-13.8,0-25,11.2-25,25s11.2,25,25,25h666.7c13.8,0,25-11.2,25-25s-11.2-25-25-25h-41.7v-343l26,20.8c10.8,8.6,26.5,6.9,35.1-3.9,8.6-10.8,6.9-26.5-3.9-35.1l-90.6-72.5ZM641.7,325.3l-194.8-155.9c-27.4-21.9-66.3-21.9-93.7,0l-194.8,155.9v383h116.7v-143.3c0-22.2,0-41.3,2.1-56.5,2.2-16.4,7.2-32.1,19.9-44.8,12.7-12.7,28.5-17.7,44.8-19.9,15.3-2.1,34.4-2.1,56.5-2.1h3.3c22.2,0,41.3,0,56.5,2.1,16.4,2.2,32.1,7.2,44.8,19.9,12.7,12.7,17.7,28.4,19.9,44.8,2.1,15.3,2.1,34.4,2.1,56.5v143.3h116.7v-383ZM475,708.3v-141.7c0-24.3,0-40-1.6-51.5-1.5-10.8-3.8-14.2-5.7-16.1-1.9-1.9-5.3-4.3-16.1-5.7-11.6-1.6-27.3-1.6-51.5-1.6s-40,0-51.5,1.6c-10.8,1.5-14.2,3.8-16.1,5.7s-4.3,5.3-5.7,16.1c-1.6,11.6-1.6,27.3-1.6,51.5v141.7h150Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400,
    cy: 316.7,
    r: 41.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 400,
    cy: 316.7,
    r: 91.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinSvgrepoCom);
export default __webpack_public_path__ + "static/media/map-pin-svgrepo-com.00e8a92850d1f29b75ab9bce7c5061e9.svg";
export { ForwardRef as ReactComponent };